import * as React from 'react';
import * as moment from 'moment';

import { IHistoryItemProps } from '../types';
import TableRow from '../../components/TableRow';
import { Tooltip } from 'src/components';

const HistoryItem: React.FC<IHistoryItemProps> = ({ item }) => (
  <TableRow
    values={[
      `${item.name} (${item.entityKey})`,
      item.message,
      <Tooltip key="date" text={item.date.replace('T', ' ').replace('Z', '')}>
        {moment(item.date).fromNow()}
      </Tooltip>,
      <div key="change" className="break-all">
        <p className="mb-1">
          <strong>New:</strong> {item.newValue}
        </p>
        <p>
          <strong>Old:</strong> {item.oldValue}
        </p>
      </div>,
      <div key="date" className="break-all">
        {`${item.userProfile.email} (${item.userProfile.id})`}
      </div>,
    ]}
    noEditForm={true}
  />
);

export default HistoryItem;



// WEBPACK FOOTER //
// ./src/views/Admin/History/components/HistoryItem.tsx